import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function MembershipIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M22 3H2a2 2 0 0 0-2 2v.829h24V5a2 2 0 0 0-2-2M8.25 12.46l-.834-.875-2.745 2.883-1.087-1.143-.834.877 1.921 2.02z" />
      <path d="M2 10.903a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-6zM12.5 15a1 1 0 1 1 .002 1.998A1 1 0 0 1 12.5 15zm-.5-2.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 1 1 0-1zm0-2h9a.5.5 0 0 1 0 1h-9a.5.5 0 1 1 0-1zm3.5 6.5a1 1 0 1 1 0-2 1 1 0 1 1 0 2zM0 18a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V7.806H0V18z"/>
    </SvgIcon>
  );
}
